module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M11.955 25.301L1.913 31.663C.857 32.332 0 31.972 0 30.854V2.576C0 1.46 1.233 0 3.138 0h17.857c1.945 0 2.915 1.098 2.915 2.576v28.278c0 1.118-.857 1.476-1.913.809l-10.042-6.362z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/bookmark-2.js
// module id = 1021
// module chunks = 14